export const DATA_MODEL_MAX_LENGTH = {
  email: 255,
  email2: 255,
  email_username: 255,
  username: 255,
  first_name: 255,
  last_name: 255,
  name: 255,
  phone: 255,
  phone2: 255,
  title: 255,
  present_employer: 255,
  status: 255,
  salary_range: 255,
  specialty_areas: 500,
  education_institution: 500,
  degree: 500,
  address1: 1024,
  address2: 1024,
  postal_code: 12,
  city: 1024,
  provincestate: 128,
  country: 40,
  website: 1024,
  facebook: 1024,
  twitter: 1024,
  instagram: 1024,
  youtube: 1024,
  linkedin: 1024,
  video: 1024,
  employer_name: 255,
  stripe_customer_id: 255,
  stripe_refresh_token: 255,
  stripe_connect_id: 255,
  organization_type: 255,
  size: 255,
  agency_owner: 255,
  second_status: 200,
  // marketing_source: 255,
  // bank: 255,
  // bank_account_type: 255,
  // bank_account_number: 255,
  // bank_account_name: 255,
  // government_ID_number: 255,
  // social_security: 255,
  category: 255
};



// WEBPACK FOOTER //
// ./src/constants/data-model-length.js